import React from "react";
import { Navigate } from "react-router-dom";
import permissionsService from "@/services/permissionsService";
import stochasticConfig from "@/navigation/stochasticNavigation";
import {
  filterNavigationByAccess,
  firstReachableHref,
} from "@/utils/navigationHelpers";

const LeadGenerationLanding: React.FC = () => {
  const { hasPermission, hasCertainPathCompany, hasCertainPathEmployee } =
    permissionsService();

  const visible = filterNavigationByAccess(
    stochasticConfig.navigation,
    hasPermission,
    hasCertainPathCompany(),
    hasCertainPathEmployee(),
  );

  return <Navigate replace to={firstReachableHref(visible) ?? "/403"} />;
};

export default LeadGenerationLanding;
